import { render, staticRenderFns } from "./MyJob.vue?vue&type=template&id=0ff4c4c6"
import script from "./MyJob.vue?vue&type=script&lang=js"
export * from "./MyJob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports